import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import React, { createContext, useState, useEffect, useContext } from 'react';
import { evaluateRunningInApp } from '../appConstants/appConstants.js';
import ipcService from './ipcService.js';
import { errorIfVerbose, enableVerboseLogging, disableVerboseLogging } from './loggingControl.js';

var IpcContext = createContext(undefined);
var IpcProvider = function (_a) {
    var children = _a.children, _b = _a.verbose, verbose = _b === void 0 ? false : _b, _c = _a.autoConnect, autoConnect = _c === void 0 ? false : _c;
    var _d = useState(ipcService.isConnected()), isConnected = _d[0], setIsConnected = _d[1];
    var _e = useState(), appInfo = _e[0], setAppInfo = _e[1];
    var mobile = evaluateRunningInApp();
    // Handle verbose logging
    useEffect(function () {
        if (verbose) {
            enableVerboseLogging();
        }
        else {
            disableVerboseLogging();
        }
    }, [verbose]);
    // Handle auto-connection
    useEffect(function () {
        var mounted = true;
        if (mobile && !isConnected && autoConnect) {
            ipcService
                .connect()
                .then(function (connection) {
                if (mounted) {
                    setIsConnected(true);
                    setAppInfo(connection.appInfo);
                }
            })
                .catch(function () {
                if (mounted) {
                    setIsConnected(false);
                }
            });
            return function () {
                mounted = false;
                if (ipcService.isConnected()) {
                    ipcService.endSession().catch(function (error) {
                        errorIfVerbose('Error ending IPC session:', error);
                    });
                }
            };
        }
        return function () {
            mounted = false;
        };
    }, [mobile, autoConnect]);
    var contextValue = {
        isConnected: isConnected,
        appInfo: appInfo,
        connect: function () { return __awaiter(void 0, void 0, void 0, function () {
            var conn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ipcService.connect()];
                    case 1:
                        conn = _a.sent();
                        setIsConnected(true);
                        setAppInfo(conn.appInfo);
                        return [2 /*return*/, conn];
                }
            });
        }); },
        ping: function () { return ipcService.ping(); },
        beginSession: function (showNativeHeader) { return ipcService.beginSession(showNativeHeader); },
        endSession: function (route) { return ipcService.endSession(route); },
        generateError: function (error) { return ipcService.generateError(error); },
        getCommands: function () {
            if (!isConnected) {
                throw new Error('Not connected to IPC context');
            }
            return ipcService.getCommands();
        },
    };
    return React.createElement(IpcContext.Provider, { value: contextValue }, children);
};
var useIpc = function () {
    var context = useContext(IpcContext);
    if (context === undefined) {
        throw new Error('useIpc must be used within an IpcProvider');
    }
    return context;
};

export { IpcProvider, useIpc };
